import * as React from 'react';
import type { TransportRouteStatus } from 'contracts/transport-routes';
import { useTranslation } from 'hooks';
import { cn } from 'lib/utils';

import { translations } from './translations';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  status: TransportRouteStatus;
}

export const TransportRouteStatusIndicator = ({
                                                className,
                                                status,
                                                ...props
                                              }: Props) => {
  const { getTranslation: t } = useTranslation(translations);

  return (
    <div {...props} className={cn(
      'flex items-center justify-center py-1 px-3 rounded-md',
      'font-GilroySemibold text-white',
      status === 'approved' && 'bg-green-600',
      status === 'pending' && 'bg-orange-400',
      status === 'rejected' && 'bg-red-600',
      className
    )}>
      {t(status)}
    </div>
  );
};